// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PostCreateEditForm_goldbright__vFhU3 {
  color: rgb(255,215,0);
}

.PostCreateEditForm_SubTitle__jAwAD {
  background-color: #e8f0f1;
  font-weight: 700;
}

/* .SubTitle {
  background-color: #5a9fa9;
  background-color: #7a7d7d;
  background-color: #868889;
  font-weight: 700;
  color: #fff;
} */

.PostCreateEditForm_Watch__lL95m {
  color: #00d1ff;
  cursor: pointer;
}

.PostCreateEditForm_SmallWhite__NVvyU {
  font-size: .75rem;
}

.PostCreateEditForm_Small__UN-MO {
  font-size: .7rem;
  color: #1da3aa;
  font-style: italic;
  }

  .PostCreateEditForm_SmallBlue__i1XvA {
  font-size: .7rem;
  color: #1da3aa;
  color: #177d82;
  font-style: italic;
  font-weight: 700;
}

  .PostCreateEditForm_Small2__EdcKi {
    font-size: .8rem;
    color: #000;
    font-weight: 700;
  }

.PostCreateEditForm_BreakTitle__rv0qq {
  border-top: 10px solid #e8f0f1;
}

.PostCreateEditForm_Break1Cos__a2J\\+2 {
  border-top: 1px solid #c1f1f7;
}

.PostCreateEditForm_Red__iWKzr {
  color: rgb(236, 32, 73);
  color: #00d1ff;
}

.PostCreateEditForm_SubTitle6__wfRvm {
    background-color: #010f13;
    padding: 20px;
    color: #fff;
    font-size: 1.25rem;
}

.PostCreateEditForm_SubTitle2__R8m-5 {
  background-color: #d6fcff;
  font-weight: 700;
}

.PostCreateEditForm_SubTitle3__AvGAb {
  background-color: #e4f2f4;
  font-weight: 700;
}

Form.PostCreateEditForm_Label__JvvUX {
  max-width: 400px;
}
.PostCreateEditForm_golddark__YuzHP {
  font-weight: 700;
  color: rgb(140, 111, 25, 99%);
}

.PostCreateEditForm_ImageDiv__YxPb- {
  border: 1px solid #dee1f7;
}

.PostCreateEditForm_ImageBox__Tnakt {
  border: 2px solid #fff;
}

.PostCreateEditForm_BoldTitleCall__PSSIT {
  font-weight: 700;
  color: #F5F5F5;
  background-color: #000;
  /* background-color: #3b444b; */
}

.PostCreateEditForm_BreakCos1__EK5Hl {
  border-top: 2px solid rgba(177, 146, 51, 0.99);
}

.PostCreateEditForm_Number__xhGb0 {
  color: #747686;
}

.PostCreateEditForm_Break__oY2nh {
  border-top: 10px solid #d0d9db;
}

.PostCreateEditForm_Break1__Is338 {
  border-top: 1px solid #d0d9db;
  /* border-top: 1px solid rgb(140, 111, 25, 99%); */
}

.PostCreateEditForm_Break2__GcNfH {
  border-top: 5px solid #d0d9db;
}

.PostCreateEditForm_Close__Lsef- {
  /* color: rgb(28, 131, 131); */
  color: rgb(32, 201, 201);
  padding-right: 5px;
  cursor: pointer;
  font-size: .75rem;
}

.PostCreateEditForm_gmailblue__sEzez {
  background-color: #f2f6fc;
}

.PostCreateEditForm_BlueLight__Yrn1Q {
  background-color: #e2ecfa;
}

.PostCreateEditForm_JiraBody__HmOav {
  color: #172b4d;
}

.PostCreateEditForm_JiraLight__ffpb0 {
  color: #808080;
}

.PostCreateEditForm_JiraLight__ffpb0 {
  color: #f6f7f9;
}

.PostCreateEditForm_JiraLightBlue__Jsh\\+r {
  color: #ebedf0;
}

.PostCreateEditForm_Container__to6V1 {
  min-height: 100px;
}

.PostCreateEditForm_Container2__SvGkd {
    min-height: 10px;
  }

.PostCreateEditForm_White__SEBjI {
  background-color: #fff;
}

.PostCreateEditForm_Whitebb__46EFE {
  background-color: #fff;
  border-bottom: 1px solid #999;
}

.PostCreateEditForm_Back__YxYTg {
  background-color: aliceblue;
}

.PostCreateEditForm_TutorialLayout__ZMaCi {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
}

.PostCreateEditForm_TutorialVideoColumn__MZUwH,
.PostCreateEditForm_TutorialContentColumn__7tQzY {
  width: 100%;
  min-width: 0;
}

.PostCreateEditForm_TutorialContentColumn__7tQzY {
  padding: 0 12px;
  text-align: center;
}

.PostCreateEditForm_TutorialVideo__E7eJW {
  display: block;
  width: 100%;
  aspect-ratio: 16 / 9;
  min-height: 315px;
}

@media screen and (max-width: 600px) {
  .PostCreateEditForm_TutorialVideo__E7eJW {
    min-height: 220px;
  }
}

.PostCreateEditForm_Bold__IBC9l {
  font-weight: 700;
}

.PostCreateEditForm_Width__CSd7J {
  width: 50%;
}

.PostCreateEditForm_Width__CSd7J {
  width: 70%;
}

.PostCreateEditForm_Width3__-hkrh {
  width: 70%;
}


.PostCreateEditForm_Width50__LzkMx {
  width: 50%;
}

.PostCreateEditForm_Width2__6HOPl {
  width: 80%;
}

.PostCreateEditForm_Width3__-hkrh {
  width: 80%;
}

.PostCreateEditForm_Width95__qp263 {
  width: 95%;
}

.PostCreateEditForm_BoldScene__nO2rT {
  color: rgba(129, 102, 21, 0.99);
  font-weight: 600;
}

.PostCreateEditForm_Input__orO\\+D {
  background: #ffffff;
  /* border: 1px solid #dee1f7; */
  border-bottom: 1px #00d1ff solid;
  border-top: 1px solid #fff;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
  box-sizing: border-box;
  border-radius: 2px;
  color: #525463;
  padding: 0px 10px;
  height: 30px !important;
  text-align: center;
}

.PostCreateEditForm_InputP__tQkdm {
  background: #ffffff;
  /* border: 1px solid #dee1f7;*/
  border-bottom: 1px #00d1ff solid;
  border-top: 1px solid #fff;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
  box-sizing: border-box;
  border-radius: 2px;
  color: #747686;
  color: #525463;
  padding: 0px 10px;
  height: 50px !important;
  text-align: center;
}

.PostCreateEditForm_InputD__-JH80 {
  background: #ffffff;
  /* border: 1px solid #dee1f7; */
  border-bottom: 1px #00d1ff solid;
  border-top: 1px solid #fff;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
  box-sizing: border-box;
  border-radius: 2px;
  color: #525463;
  padding: 0px 10px;
  height: 30px !important;
  text-align: center;
  width: 100%;
}

.PostCreateEditForm_InputSceneDept__yVpDT {
  background: #ffffff;
  /* border: 1px solid #dee1f7; */
  border-bottom: 1px #00d1ff solid;
  border-top: 1px solid #fff;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
  box-sizing: border-box;
  border-radius: 2px;
  color: #525463;
  padding: 0px 10px;
  text-align: center;
}

.PostCreateEditForm_InputEx__aGBup {
  background: #ffffff;
  /* border: 1px solid #dee1f7; */
  border-bottom: 1px #00d1ff solid;
  border-top: 1px solid #fff;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
  box-sizing: border-box;
  border-radius: 2px;
  color: #525463;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 30px;
  height: 30px !important;
  text-align: center;
}

.PostCreateEditForm_InputScene__JYMKE {
 background: #ffffff;
 /* border: 1px solid #dee1f7; */
 border-bottom: 1px #00d1ff solid;
  border-top: 1px solid #fff;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
 box-sizing: border-box;
 border-radius: 2px;
 color: #525463;
 padding: 0px 10px;
 min-height: 30px !important;
 text-align: center;
 /* border-bottom: 1px #00d1ff solid;
  border-top: 1px solid #fff;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff; */
}

.PostCreateEditForm_InputDept__KSv1L {
  background: #ffffff;
  /* border: 1px solid #dee1f7;
  border-bottom: 1px #00d1ff solid; */
  border-bottom: 1px #00d1ff solid;
  border-top: 1px solid #fff;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
  box-sizing: border-box;
  border-radius: 2px;
  color: #525463;
  padding-left: 35px;
  padding-top: 0px;
  padding-bottom: 0px;
  height: 30px !important;
  text-align: center;
}

.PostCreateEditForm_InputChar__bxYlS {
 background: #ffffff;
 /* border: 1px solid #dee1f7;
 border-bottom: 1px #00d1ff solid; */
 border-bottom: 1px #00d1ff solid;
  border-top: 1px solid #fff;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
 box-sizing: border-box;
 border-radius: 2px;
 color: #525463;
 padding: 0px 0px;
 height: 30px !important;
 text-align: center;
}

.PostCreateEditForm_BoldTitle__jVzzg {
  font-weight: 700;
  background-color: rgb(209, 240, 240);
}

/* @media screen and (max-width: 600px) {
  p {
    font-size: .75rem;
  }} */

  @media screen and (max-width: 780px) {
  .PostCreateEditForm_Width3__-hkrh {
    width: 50%;
  }

  .PostCreateEditForm_ImageBox__Tnakt {
    border: 2px solid #dee1f7;
  }
}

@media screen and (max-width: 600px) {
  .PostCreateEditForm_BoldScene__nO2rT {
    font-size: .75rem;
  }

  .PostCreateEditForm_Input__orO\\+D {
    height: 20px !important;
    text-align: center;
    font-size: .75rem !important;
  }

  .PostCreateEditForm_InputD__-JH80 {
    height: 20px !important;
    text-align: center;
    font-size: .75rem !important;
  }

  .PostCreateEditForm_InputP__tQkdm {
    height: 20px !important;
    text-align: center;
    font-size: .75rem !important;
  }

  .PostCreateEditForm_InputScene__JYMKE {
    font-size: .75rem !important;
   }
   
  .PostCreateEditForm_Width__CSd7J {
    width: 90%;
  }

  .PostCreateEditForm_Width2__6HOPl {
    width: 90%;
  }

  .PostCreateEditForm_Width95__qp263 {
    width: 100%;
  }

  h1 {
    font-size: 1.75rem;
  }

  h2 {
    font-size: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/PostCreateEditForm.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;;;;;GAMG;;AAEH;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB;;EAEA;EACA,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;EAEE;IACE,gBAAgB;IAChB,WAAW;IACX,gBAAgB;EAClB;;AAEF;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,WAAW;IACX,kBAAkB;AACtB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,kDAAkD;AACpD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;IACI,gBAAgB;EAClB;;AAEF;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;EAChC,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;EAChC,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;EAChC,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;EAChC,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;EAChC,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;CACC,mBAAmB;CACnB,+BAA+B;CAC/B,gCAAgC;EAC/B,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;CAC5B,sBAAsB;CACtB,kBAAkB;CAClB,cAAc;CACd,iBAAiB;CACjB,2BAA2B;CAC3B,kBAAkB;CAClB;;;gCAG+B;AAChC;;AAEA;EACE,mBAAmB;EACnB;qCACmC;EACnC,gCAAgC;EAChC,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;CACC,mBAAmB;CACnB;oCACmC;CACnC,gCAAgC;EAC/B,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;CAC5B,sBAAsB;CACtB,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,uBAAuB;CACvB,kBAAkB;AACnB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;;;MAGM;;EAEJ;EACA;IACE,UAAU;EACZ;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;GAC7B;;EAED;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".goldbright {\n  color: rgb(255,215,0);\n}\n\n.SubTitle {\n  background-color: #e8f0f1;\n  font-weight: 700;\n}\n\n/* .SubTitle {\n  background-color: #5a9fa9;\n  background-color: #7a7d7d;\n  background-color: #868889;\n  font-weight: 700;\n  color: #fff;\n} */\n\n.Watch {\n  color: #00d1ff;\n  cursor: pointer;\n}\n\n.SmallWhite {\n  font-size: .75rem;\n}\n\n.Small {\n  font-size: .7rem;\n  color: #1da3aa;\n  font-style: italic;\n  }\n\n  .SmallBlue {\n  font-size: .7rem;\n  color: #1da3aa;\n  color: #177d82;\n  font-style: italic;\n  font-weight: 700;\n}\n\n  .Small2 {\n    font-size: .8rem;\n    color: #000;\n    font-weight: 700;\n  }\n\n.BreakTitle {\n  border-top: 10px solid #e8f0f1;\n}\n\n.Break1Cos {\n  border-top: 1px solid #c1f1f7;\n}\n\n.Red {\n  color: rgb(236, 32, 73);\n  color: #00d1ff;\n}\n\n.SubTitle6 {\n    background-color: #010f13;\n    padding: 20px;\n    color: #fff;\n    font-size: 1.25rem;\n}\n\n.SubTitle2 {\n  background-color: #d6fcff;\n  font-weight: 700;\n}\n\n.SubTitle3 {\n  background-color: #e4f2f4;\n  font-weight: 700;\n}\n\nForm.Label {\n  max-width: 400px;\n}\n.golddark {\n  font-weight: 700;\n  color: rgb(140, 111, 25, 99%);\n}\n\n.ImageDiv {\n  border: 1px solid #dee1f7;\n}\n\n.ImageBox {\n  border: 2px solid #fff;\n}\n\n.BoldTitleCall {\n  font-weight: 700;\n  color: #F5F5F5;\n  background-color: #000;\n  /* background-color: #3b444b; */\n}\n\n.BreakCos1 {\n  border-top: 2px solid rgba(177, 146, 51, 0.99);\n}\n\n.Number {\n  color: #747686;\n}\n\n.Break {\n  border-top: 10px solid #d0d9db;\n}\n\n.Break1 {\n  border-top: 1px solid #d0d9db;\n  /* border-top: 1px solid rgb(140, 111, 25, 99%); */\n}\n\n.Break2 {\n  border-top: 5px solid #d0d9db;\n}\n\n.Close {\n  /* color: rgb(28, 131, 131); */\n  color: rgb(32, 201, 201);\n  padding-right: 5px;\n  cursor: pointer;\n  font-size: .75rem;\n}\n\n.gmailblue {\n  background-color: #f2f6fc;\n}\n\n.BlueLight {\n  background-color: #e2ecfa;\n}\n\n.JiraBody {\n  color: #172b4d;\n}\n\n.JiraLight {\n  color: #808080;\n}\n\n.JiraLight {\n  color: #f6f7f9;\n}\n\n.JiraLightBlue {\n  color: #ebedf0;\n}\n\n.Container {\n  min-height: 100px;\n}\n\n.Container2 {\n    min-height: 10px;\n  }\n\n.White {\n  background-color: #fff;\n}\n\n.Whitebb {\n  background-color: #fff;\n  border-bottom: 1px solid #999;\n}\n\n.Back {\n  background-color: aliceblue;\n}\n\n.TutorialLayout {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 16px;\n}\n\n.TutorialVideoColumn,\n.TutorialContentColumn {\n  width: 100%;\n  min-width: 0;\n}\n\n.TutorialContentColumn {\n  padding: 0 12px;\n  text-align: center;\n}\n\n.TutorialVideo {\n  display: block;\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  min-height: 315px;\n}\n\n@media screen and (max-width: 600px) {\n  .TutorialVideo {\n    min-height: 220px;\n  }\n}\n\n.Bold {\n  font-weight: 700;\n}\n\n.Width {\n  width: 50%;\n}\n\n.Width {\n  width: 70%;\n}\n\n.Width3 {\n  width: 70%;\n}\n\n\n.Width50 {\n  width: 50%;\n}\n\n.Width2 {\n  width: 80%;\n}\n\n.Width3 {\n  width: 80%;\n}\n\n.Width95 {\n  width: 95%;\n}\n\n.BoldScene {\n  color: rgba(129, 102, 21, 0.99);\n  font-weight: 600;\n}\n\n.Input {\n  background: #ffffff;\n  /* border: 1px solid #dee1f7; */\n  border-bottom: 1px #00d1ff solid;\n  border-top: 1px solid #fff;\n  border-right: 1px solid #fff;\n  border-left: 1px solid #fff;\n  box-sizing: border-box;\n  border-radius: 2px;\n  color: #525463;\n  padding: 0px 10px;\n  height: 30px !important;\n  text-align: center;\n}\n\n.InputP {\n  background: #ffffff;\n  /* border: 1px solid #dee1f7;*/\n  border-bottom: 1px #00d1ff solid;\n  border-top: 1px solid #fff;\n  border-right: 1px solid #fff;\n  border-left: 1px solid #fff;\n  box-sizing: border-box;\n  border-radius: 2px;\n  color: #747686;\n  color: #525463;\n  padding: 0px 10px;\n  height: 50px !important;\n  text-align: center;\n}\n\n.InputD {\n  background: #ffffff;\n  /* border: 1px solid #dee1f7; */\n  border-bottom: 1px #00d1ff solid;\n  border-top: 1px solid #fff;\n  border-right: 1px solid #fff;\n  border-left: 1px solid #fff;\n  box-sizing: border-box;\n  border-radius: 2px;\n  color: #525463;\n  padding: 0px 10px;\n  height: 30px !important;\n  text-align: center;\n  width: 100%;\n}\n\n.InputSceneDept {\n  background: #ffffff;\n  /* border: 1px solid #dee1f7; */\n  border-bottom: 1px #00d1ff solid;\n  border-top: 1px solid #fff;\n  border-right: 1px solid #fff;\n  border-left: 1px solid #fff;\n  box-sizing: border-box;\n  border-radius: 2px;\n  color: #525463;\n  padding: 0px 10px;\n  text-align: center;\n}\n\n.InputEx {\n  background: #ffffff;\n  /* border: 1px solid #dee1f7; */\n  border-bottom: 1px #00d1ff solid;\n  border-top: 1px solid #fff;\n  border-right: 1px solid #fff;\n  border-left: 1px solid #fff;\n  box-sizing: border-box;\n  border-radius: 2px;\n  color: #525463;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  padding-left: 30px;\n  height: 30px !important;\n  text-align: center;\n}\n\n.InputScene {\n background: #ffffff;\n /* border: 1px solid #dee1f7; */\n border-bottom: 1px #00d1ff solid;\n  border-top: 1px solid #fff;\n  border-right: 1px solid #fff;\n  border-left: 1px solid #fff;\n box-sizing: border-box;\n border-radius: 2px;\n color: #525463;\n padding: 0px 10px;\n min-height: 30px !important;\n text-align: center;\n /* border-bottom: 1px #00d1ff solid;\n  border-top: 1px solid #fff;\n  border-right: 1px solid #fff;\n  border-left: 1px solid #fff; */\n}\n\n.InputDept {\n  background: #ffffff;\n  /* border: 1px solid #dee1f7;\n  border-bottom: 1px #00d1ff solid; */\n  border-bottom: 1px #00d1ff solid;\n  border-top: 1px solid #fff;\n  border-right: 1px solid #fff;\n  border-left: 1px solid #fff;\n  box-sizing: border-box;\n  border-radius: 2px;\n  color: #525463;\n  padding-left: 35px;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  height: 30px !important;\n  text-align: center;\n}\n\n.InputChar {\n background: #ffffff;\n /* border: 1px solid #dee1f7;\n border-bottom: 1px #00d1ff solid; */\n border-bottom: 1px #00d1ff solid;\n  border-top: 1px solid #fff;\n  border-right: 1px solid #fff;\n  border-left: 1px solid #fff;\n box-sizing: border-box;\n border-radius: 2px;\n color: #525463;\n padding: 0px 0px;\n height: 30px !important;\n text-align: center;\n}\n\n.BoldTitle {\n  font-weight: 700;\n  background-color: rgb(209, 240, 240);\n}\n\n/* @media screen and (max-width: 600px) {\n  p {\n    font-size: .75rem;\n  }} */\n\n  @media screen and (max-width: 780px) {\n  .Width3 {\n    width: 50%;\n  }\n\n  .ImageBox {\n    border: 2px solid #dee1f7;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .BoldScene {\n    font-size: .75rem;\n  }\n\n  .Input {\n    height: 20px !important;\n    text-align: center;\n    font-size: .75rem !important;\n  }\n\n  .InputD {\n    height: 20px !important;\n    text-align: center;\n    font-size: .75rem !important;\n  }\n\n  .InputP {\n    height: 20px !important;\n    text-align: center;\n    font-size: .75rem !important;\n  }\n\n  .InputScene {\n    font-size: .75rem !important;\n   }\n   \n  .Width {\n    width: 90%;\n  }\n\n  .Width2 {\n    width: 90%;\n  }\n\n  .Width95 {\n    width: 100%;\n  }\n\n  h1 {\n    font-size: 1.75rem;\n  }\n\n  h2 {\n    font-size: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"goldbright": `PostCreateEditForm_goldbright__vFhU3`,
	"SubTitle": `PostCreateEditForm_SubTitle__jAwAD`,
	"Watch": `PostCreateEditForm_Watch__lL95m`,
	"SmallWhite": `PostCreateEditForm_SmallWhite__NVvyU`,
	"Small": `PostCreateEditForm_Small__UN-MO`,
	"SmallBlue": `PostCreateEditForm_SmallBlue__i1XvA`,
	"Small2": `PostCreateEditForm_Small2__EdcKi`,
	"BreakTitle": `PostCreateEditForm_BreakTitle__rv0qq`,
	"Break1Cos": `PostCreateEditForm_Break1Cos__a2J+2`,
	"Red": `PostCreateEditForm_Red__iWKzr`,
	"SubTitle6": `PostCreateEditForm_SubTitle6__wfRvm`,
	"SubTitle2": `PostCreateEditForm_SubTitle2__R8m-5`,
	"SubTitle3": `PostCreateEditForm_SubTitle3__AvGAb`,
	"Label": `PostCreateEditForm_Label__JvvUX`,
	"golddark": `PostCreateEditForm_golddark__YuzHP`,
	"ImageDiv": `PostCreateEditForm_ImageDiv__YxPb-`,
	"ImageBox": `PostCreateEditForm_ImageBox__Tnakt`,
	"BoldTitleCall": `PostCreateEditForm_BoldTitleCall__PSSIT`,
	"BreakCos1": `PostCreateEditForm_BreakCos1__EK5Hl`,
	"Number": `PostCreateEditForm_Number__xhGb0`,
	"Break": `PostCreateEditForm_Break__oY2nh`,
	"Break1": `PostCreateEditForm_Break1__Is338`,
	"Break2": `PostCreateEditForm_Break2__GcNfH`,
	"Close": `PostCreateEditForm_Close__Lsef-`,
	"gmailblue": `PostCreateEditForm_gmailblue__sEzez`,
	"BlueLight": `PostCreateEditForm_BlueLight__Yrn1Q`,
	"JiraBody": `PostCreateEditForm_JiraBody__HmOav`,
	"JiraLight": `PostCreateEditForm_JiraLight__ffpb0`,
	"JiraLightBlue": `PostCreateEditForm_JiraLightBlue__Jsh+r`,
	"Container": `PostCreateEditForm_Container__to6V1`,
	"Container2": `PostCreateEditForm_Container2__SvGkd`,
	"White": `PostCreateEditForm_White__SEBjI`,
	"Whitebb": `PostCreateEditForm_Whitebb__46EFE`,
	"Back": `PostCreateEditForm_Back__YxYTg`,
	"TutorialLayout": `PostCreateEditForm_TutorialLayout__ZMaCi`,
	"TutorialVideoColumn": `PostCreateEditForm_TutorialVideoColumn__MZUwH`,
	"TutorialContentColumn": `PostCreateEditForm_TutorialContentColumn__7tQzY`,
	"TutorialVideo": `PostCreateEditForm_TutorialVideo__E7eJW`,
	"Bold": `PostCreateEditForm_Bold__IBC9l`,
	"Width": `PostCreateEditForm_Width__CSd7J`,
	"Width3": `PostCreateEditForm_Width3__-hkrh`,
	"Width50": `PostCreateEditForm_Width50__LzkMx`,
	"Width2": `PostCreateEditForm_Width2__6HOPl`,
	"Width95": `PostCreateEditForm_Width95__qp263`,
	"BoldScene": `PostCreateEditForm_BoldScene__nO2rT`,
	"Input": `PostCreateEditForm_Input__orO+D`,
	"InputP": `PostCreateEditForm_InputP__tQkdm`,
	"InputD": `PostCreateEditForm_InputD__-JH80`,
	"InputSceneDept": `PostCreateEditForm_InputSceneDept__yVpDT`,
	"InputEx": `PostCreateEditForm_InputEx__aGBup`,
	"InputScene": `PostCreateEditForm_InputScene__JYMKE`,
	"InputDept": `PostCreateEditForm_InputDept__KSv1L`,
	"InputChar": `PostCreateEditForm_InputChar__bxYlS`,
	"BoldTitle": `PostCreateEditForm_BoldTitle__jVzzg`
};
export default ___CSS_LOADER_EXPORT___;
